import React, {useState, useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {getChatName} from 'ag-common/tools/chat'
import actions from 'redux-auto'
import AddChatParticipantModal from '#components/o/Chat/AddChatParticipantModal'
import CloseIcon from '#components/svg/icons/Close'
import EditPen from '#components/svg/icons/EditPen'
import Api from '#services/api'
import Input from '#components/a/form/Input'
import Headline from '#components/a/Headline'
import {usePermissions} from '#hooks/usePermissions'

export default function ChatDetailHeader({chat, setIsShowingParticipants, isShowingParticipants, participantsCount}) {
  const permissions = usePermissions()
  const [isEditingName, setIsEditingName] = useState(false)
  const [newName, setNewName] = useState(chat.name || '')
  const isGroupChat = participantsCount > 2
  const canRenameChat = permissions.chat.createOrRename
  const inputElement = useRef(null)

  useEffect(() => {
    setNewName(chat.name || '')
  }, [chat])

  useEffect(() => {
    if (inputElement.current && isEditingName) {
      inputElement.current.focus()
    }
  }, [isEditingName])

  const chatHeaderParticipantsButton = () => (
    <button className="participants" type="button" onClick={() => setIsShowingParticipants(true)}>
      {i18n.t('chat_detail_header_participants', [participantsCount])}
    </button>
  )

  const chatHeaderCloseParticipantsButton = () => (
    <button type="button" className="close-participants" onClick={() => setIsShowingParticipants(false)}>
      <CloseIcon />
    </button>
  )

  const chatHeaderEditChatnameButton = () => (
    <button
      data-testid="button-edit-chatname"
      type="button"
      className="button--edit-chatname"
      onClick={() => {
        setIsEditingName(true)
      }}
    >
      <EditPen />
    </button>
  )

  const updateName = () => {
    ;(async () => {
      try {
        await Api.updateChat({chatId: chat.id, name: newName})
      } catch (error) {
        actions.error.writeError({error})
      } finally {
        setIsEditingName(false)
      }
    })()
  }

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      updateName()
    }
  }

  const renderChatName = () => {
    if (isEditingName) {
      return (
        <div className="input">
          <Input
            reference={inputElement}
            maxLength={25}
            type="text"
            value={newName}
            placeholder="Gruppenname"
            onChangeHandle={event => setNewName(event.target.value)}
            onBlurHandle={updateName}
            onKeyDown={e => handleKeyPress(e)}
            testid="input-chatname"
          />
        </div>
      )
    }
    return <Headline importance={2} text={getChatName(chat, i18n.t('unknown_user'))} />
  }

  const showChatnameEditButton = canRenameChat && isGroupChat && !isEditingName

  return (
    <div className="chat-detail_header">
      {isShowingParticipants && chatHeaderCloseParticipantsButton()}
      <div className="header_content">
        <div className="chat-name">
          {renderChatName()}
          {showChatnameEditButton && chatHeaderEditChatnameButton()}
        </div>
        {isGroupChat && chatHeaderParticipantsButton()}
      </div>
      <AddChatParticipantModal chatId={chat.id} />
    </div>
  )
}

ChatDetailHeader.propTypes = {
  chat: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    participants: PropTypes.array.isRequired,
  }).isRequired,
  isShowingParticipants: PropTypes.bool,
  participantsCount: PropTypes.number,
  setIsShowingParticipants: PropTypes.func,
}
